// extracted by mini-css-extract-plugin
module.exports = {"cropper-modal":"CropperModal_cropper-modal__TY_eH"};